module.exports = __webpack_public_path__ + "static/media/extendwaranty.ef61cefa.png";